import { Icon } from '../../../../components/icons'
import { Button } from '../../../../components/ui/button'
import { Modal } from '../../../../components/ui/modal'
import { CopyText } from '../../../../utils/general'
import { ClientsFormModalInfoCandidacyLayout } from '../_form/clientsFormModalInfoCandidacyLayout'

export const ModalInfoCandidacy = ({
  active,
  setActive,
  values,
  actions = {
    setBlocked: () => {},
    setFavorite: () => {},
  },
  infosContext,
}) => {
  const infoCandidacySelected = values?.infoCandidacySelected || {}

  return (
    <Modal.Root active={active}>
      <Modal.Contents>
        <Modal.Header>
          <div className="modal-card-title" style={{ marginBottom: -15 }}>
            <div className="is-flex is-align-items-center">
              <span>Candidatura</span>

              <span className="tag is-light ml-2">Id: {infoCandidacySelected.id}</span>

              <Button.Bt className="is-small ml-2" action={() => CopyText(infoCandidacySelected.id)}>
                <Icon size={10}>copy</Icon>
              </Button.Bt>
            </div>

            <div className="mt-2">
              <span className={`tag ${infoCandidacySelected?.status?.color} mr-2`}>
                {infoCandidacySelected?.status?.status}
              </span>

              {infoCandidacySelected?.motivo ||
                (infoCandidacySelected.reason && (
                  <span className="tag is-light">
                    Motivo: {infoCandidacySelected.motivo || infoCandidacySelected.reason}
                  </span>
                ))}
            </div>
          </div>

          <Modal.HeaderClose setActive={setActive} />
        </Modal.Header>
        <Modal.Body>
          <ClientsFormModalInfoCandidacyLayout
            formContext={values}
            infosContext={infosContext}
          ></ClientsFormModalInfoCandidacyLayout>
        </Modal.Body>
        <Modal.Footer>
          {/* {// console.log(values?.favorite)} */}
          <Button.Bt
            color={infoCandidacySelected?.favorite ? 'is-danger' : 'is-light'}
            title="Favoritar"
            action={() => {
              actions.setFavorite(infoCandidacySelected?.uuid)
            }}
          >
            <Icon>favorite</Icon>
          </Button.Bt>
          <Button.Bt
            color={infoCandidacySelected?.blocked ? 'is-danger' : 'is-light'}
            title="Bloquear Candidaturas"
            action={() => {
              actions.setBlocked(infoCandidacySelected?.uuid)
            }}
          >
            <Icon>block</Icon>
          </Button.Bt>
        </Modal.Footer>
        <p className={`mx-2 is-size-7`} style={{ position: 'absolute', bottom: 40, right: 15 }}>
          Candidatura criada em:
          <p className={`tag mx-1`}>{infoCandidacySelected?.dt_created}</p>
        </p>

        {infoCandidacySelected?.userUpdate && infoCandidacySelected?.dtUpdate && (
          <p className={`mx-2 is-size-7`} style={{ position: 'absolute', bottom: 15, right: 15 }}>
            Ultima Modificação:
            <p className={`tag mx-1`}>{infoCandidacySelected?.userUpdate}</p>em:
            <p className={`tag mx-1`}>{infoCandidacySelected?.dtUpdate}</p>
          </p>
        )}
      </Modal.Contents>
    </Modal.Root>
  )
}
